import axiosInstance from './axiosInstance';

// Fetches the currently logged-in driver's own profile.
export async function getDriverProfile() {
  const response = await axiosInstance.get('/drivers/get-driver.php');
  return response.data;
}